import { billingSelectorToString, } from '@debbie/common/dist/economy/billing/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/billing.js';
import q from '../query.js';
import { casesEntity } from '../cases/index.js';
import { creditorsEntity } from '../creditors/index.js';
import { billingVouchersEntity } from '../billing-vouchers/index.js';
import { tenantsEntity } from '../tenant/index.js';
export const billingsEntity = `billings`;
const ongoingWorkKey = (caseId, creditorId) => `billing-ongoing-work-${creditorId}-${caseId}`;
export const useOngoingWork = (p) => q.query(ongoingWorkKey(p?.caseId, p?.creditorId), () => api.getOngoingWork(p), [
    // Changing cases or creditors can have an impact on ongoing work (billing model etc.)
    ...keys.read.collection(casesEntity),
    ...keys.read.collection(creditorsEntity),
    ...keys.read.collection(tenantsEntity),
    ...keys.read.collection(billingsEntity),
    ...keys.read.collection(billingVouchersEntity),
]);
const billingCollectionsKey = (caseId, creditorId) => `billing-collections-${creditorId}-${caseId}`;
export const useBillingCollections = (p) => q.query(billingCollectionsKey(p?.caseId, p?.creditorId), () => api.getCollections(p), [
    ...keys.read.collection(billingsEntity),
    ...keys.read.collection(billingVouchersEntity),
]);
const billingKey = (billingId) => `billing-${billingId}`;
export const useBilling = (billingId) => q.query(billingKey(billingId), () => api.getById(billingId), [
    ...keys.read.item(billingsEntity, billingId),
    ...keys.read.collection(billingVouchersEntity),
]);
const ongoingWorkBillingKey = (billingSelector) => `ongoing-work-billing-${billingSelectorToString(billingSelector)}`;
export const useOngoingWorkBilling = (billingSelector) => q.query(ongoingWorkBillingKey(billingSelector), () => api.getByBillingSelector(billingSelector), [
    // Changing cases or creditors can have an impact on ongoing work (billing model etc.)
    ...keys.read.collection(casesEntity),
    ...keys.read.collection(creditorsEntity),
    ...keys.read.collection(tenantsEntity),
    ...keys.read.collection(billingsEntity),
    ...keys.read.collection(billingVouchersEntity),
]);
const billingsKey = (query) => `billings-${query?.caseId}-${query?.creditorId}-${query?.depositCaseVoucherId}-${query?.billingCollectionId}-${query?.currency}-${query?.billingAppendixId}`;
export const useBillings = (query) => q.query(billingsKey(query), () => api.getMultiple(query), [
    ...keys.read.collection(billingsEntity),
    ...keys.read.collection(billingVouchersEntity),
]);
//# sourceMappingURL=index.js.map